import type { StrapiMedia } from '~/types/strapi';

/**
 * Converts a plain filename (written by vehicle-sync directly to the uploads
 * directory) into a minimal StrapiMedia-compatible object that SharedPicture
 * can consume. imgproxy handles all resizing; we only need the url.
 */
function filenameToMedia(filename: string): StrapiMedia {
  return {
    url: `/uploads/${filename}`,
    width: 1920,
    height: 1080,
    alternativeText: '',
    formats: null,
    caption: null,
  } as unknown as StrapiMedia;
}

/**
 * Returns a unified image array for a vehicle.
 * Prefers vehicle_image_files (Go sync) over images (legacy upload-plugin).
 */
export function useVehicleImages(vehicle: {
  images?: StrapiMedia[] | Array<{ url: string; [key: string]: any }> | null;
  vehicle_image_files?: string[] | null;
}): StrapiMedia[] {
  if (vehicle.vehicle_image_files?.length) {
    return vehicle.vehicle_image_files.map(filenameToMedia);
  }
  return (vehicle.images ?? []) as StrapiMedia[];
}
